import styled from 'styled-components'
import BackButton from '~/app/components/BackButton'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

export const HeaderStyles = {
  Root: styled.header<{ $hasColoredBg?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: var(
      --header-bg,
      ${({ $hasColoredBg }) =>
        $hasColoredBg ? COLORS.GRAY_100 : 'transparent'}
    );
  `,

  Container: styled.div`
    width: 100%;
    max-width: ${BREAKPOINTS[375]}px;
    margin: 0 auto;
    padding: 0 16px;
  `,

  HeaderRow: styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 53px;
  `,

  Logo: styled.img`
    margin: 0 auto;
    max-width: 125px;
  `,

  StyledBackButton: styled(BackButton)`
    position: absolute;
    top: 50%;
    inset-inline-start: 0;
    transform: translateY(-50%);
    padding: 10px;
  `,

  ProgressArea: styled.div`
    height: 35px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
  `,

  SectionLabel: styled.span`
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: ${COLORS.BLACK};
  `,

  Progress: styled.progress`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: ${BREAKPOINTS[426]}px;
    appearance: none;
    border: none;
    height: 2px;
    overflow: hidden;

    @media (min-width: ${BREAKPOINTS[426]}px) {
      max-width: ${BREAKPOINTS[375]}px;
      left: 50%;
      transform: translateX(-50%);
    }

    &::-webkit-progress-bar {
      background: ${COLORS.WHITE};
    }

    &::-webkit-progress-value {
      background: ${COLORS.PURPLE_400};
      transition: all 0.2s ease-out;
    }

    &::-moz-progress-bar {
      background: ${COLORS.PURPLE_400};
      transition: all 0.2s ease-out;
    }

    &::-ms-fill {
      background: ${COLORS.PURPLE_400};
      transition: all 0.2s ease-out;
    }
  `,

  CommunicationProgress: styled.progress`
    display: block;
    width: 100%;
    height: 4px;
    margin-top: 8px;
    appearance: none;
    border: none;
    border-radius: 2px;
    overflow: hidden;

    &::-webkit-progress-bar {
      background: #e5e7eb;
    }

    &::-webkit-progress-value {
      background: #096ef9;
      transition: width 0.2s ease-out;
    }

    &::-moz-progress-bar {
      background: #096ef9;
      transition: width 0.2s ease-out;
    }
  `,

  CommunicationDivider: styled.div`
    width: 100%;
    height: 1px;
    background-color: #e5e7eb;
    margin-top: 12px;
  `,

  SegmentsWrapper: styled.div`
    width: 100%;
    display: flex;
    gap: 4px;
  `,

  Segment: styled.div`
    flex: 1;
  `,

  SegmentProgress: styled.progress`
    display: block;
    width: 100%;
    height: 4px;
    appearance: none;
    border: none;
    border-radius: 8px;
    overflow: hidden;
    background-color: ${COLORS.GRAY_400};

    &::-webkit-progress-bar {
      background-color: ${COLORS.GRAY_400};
      border-radius: 8px;
    }

    &::-webkit-progress-value {
      background-color: ${COLORS.PURPLE_400};
      border-radius: 8px;
      transition: width 0.2s ease-out;
    }

    &::-moz-progress-bar {
      background-color: ${COLORS.PURPLE_400};
      border-radius: 8px;
      transition: width 0.2s ease-out;
    }
  `,
} as const
